module.exports = __webpack_public_path__ + "static/media/watch.b7a04add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/watch.jpg
// module id = 1193
// module chunks = 33